import React, { useEffect, useState } from "react";
import "./Compliances_data.scss";
import { gql, useMutation, useQuery } from "@apollo/client";
import { ErrorToast, SuccessToast } from "../ToastComponent/RectHotToast";
import { EDIT_COMPLIANCE_REMAINDER, GET_COMPLIANCE_REMAINDER } from "../../../Utils/AllPagesQuriesAndMutations";
import Reactportal from "../Reactportal/Reactportal";
import axios from "axios";

const Compliances_data = ({ showCompleted }) => {
  const [compliance, setCompliance] = useState([]);
  const [isOpen, setIsOpen] = useState(null);
  const [file, setFile] = useState(null);
  const [notes, setNotes] = useState({});
  const [hiddenItem, setHiddenItem] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploading, setUploading] = useState(false);

  const { data, refetch } = useQuery(GET_COMPLIANCE_REMAINDER, {
    variables: { isComplete: showCompleted },
    fetchPolicy: "network-only",
  });

  const [editCompliance] = useMutation(EDIT_COMPLIANCE_REMAINDER, {
    onCompleted: (response) => {
      const updatedCompliance = response.editcompliancesReminder;
      setCompliance((prev) =>
        prev.map((item) =>
          item._id === updatedCompliance._id
            ? { ...item, notes: updatedCompliance.notes, file: updatedCompliance.file }
            : item
        )
      );
      SuccessToast("Compliance updated successfully!");
    },
    onError: (err) => {
      console.error("Error:", err);
      ErrorToast("Failed to update compliance.");
    },
  });

  useEffect(() => {
    if (data?.getcompliancesReminderForYear) {
      setCompliance([...data.getcompliancesReminderForYear]);
    }
  }, [data]);

  const toggleOpen = (id) => {
    setIsOpen((prevId) => (prevId === id ? null : id));
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      ErrorToast("Please select a file.");
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      // formData.append("file", selectedFile);
      console.log(selectedFile, "selectedFileselectedFileselectedFile");

      const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/upload/single`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setFile({
        name: data.fileName,
        url: data.fileURL,
      });
      // setSelectedFile(URL.createObjectURL(selectedFile));
      // setIsModalOpen(true);
      SuccessToast("File uploaded successfully!");
    } catch (err) {
      console.error("Upload Error:", err);
      ErrorToast("File upload failed.");
    } finally {
      setUploading(false);
    }
  };

  const handleNotesChange = (id, value) => {
    setNotes((prev) => ({ ...prev, [id]: value }));
  };

  const compliaanceHandleSubmit = async (id, isComplete) => {
    try {
      await editCompliance({
        variables: {
          editcompliancesReminderId: id,
          userInput: {
            notes: notes[id] || "",
            file: file ? file.url : null,
            isComplete: isComplete,
          },
        },
      });
      await refetch();
    } catch (err) {
      console.error("Submission Error:", err);
      ErrorToast("Failed to update compliance.");
    }
  };

  const handleCheckBox = (id, currentStatus) => {
    compliaanceHandleSubmit(id, !currentStatus);
  };
  const formatDate = (dateString) => {
    if (!dateString) return "No Due Date";
    const date = new Date(dateString);
    if (isNaN(date)) return "Invalid date";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="Compliances_data">
      {compliance.map((compliance) => {
        const { _id, compliancesMasterData, notes: savedNotes, dueDate } = compliance || {};
        const name = compliancesMasterData?.name || "No name";
        const description = compliancesMasterData?.description || "No description";
        const isOpenItem = isOpen === _id;

        return (
          <div key={_id} className="compliance_item">
            <div className="header-controls">
              <div className="checkbox-area">
                <input
                  type="checkbox"
                  checked={compliance.isComplete}
                  onChange={() => handleCheckBox(_id, compliance.isComplete)}
                />
                <input type="text" placeholder="name" value={name} readOnly className="hover-input" />
              </div>

              <div className="due-date-display">{formatDate(dueDate)}</div>

              <button className="compliance-toggle-button" onClick={() => toggleOpen(_id)}>
                {isOpenItem ? "▲" : "▼"}
              </button>
            </div>

            {isOpenItem && (
              <div className="Compliances_content">
                <div className="Compliances_info">
                  <div className="Compliances_row">
                    <div className="Compliances_notes">
                      <label>Notes</label>
                      <textarea
                        value={notes[_id] ?? savedNotes ?? ""}
                        onChange={(e) => handleNotesChange(_id, e.target.value)}
                      ></textarea>
                    </div>
                    <div className="Compliances_decription">
                      <span>Description</span>
                      <textarea value={description} readOnly></textarea>
                    </div>
                  </div>

                  <div className="Compliances_row">
                    <div className="file-upload">
                      <label>Add File:</label>
                      <input type="file" onChange={handleFileChange} />
                      {uploading && <p>Uploading...</p>}

                      {isModalOpen && (
                        <Reactportal
                          open={true}
                          onClose={() => {
                            setIsModalOpen(false);
                          }}
                          TypeOfPortal={"File Upload"}
                        >
                          <img
                            src={selectedFile}
                            alt="Selected File"
                            style={{ height: "600px", width: "600px" }}
                            className="fileUploadIcon"
                          />
                        </Reactportal>
                      )}
                    </div>

                    <button className="complianceSubmit" onClick={() => compliaanceHandleSubmit(_id)}>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Compliances_data;
